import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './index.css';
import RootView from './RootView';
import AdminLogin from './Admin/AdminLogin';
import AdminDashboard from './Admin/AdminDashboard';
import AddPC from './Admin/pages/AddPC';
import EditPCList from './Admin/pages/EditPCList';
import EditPCDetails from './Admin/pages/EditPCDetails';
import AddComponent from './Admin/pages/AddComponent';
import EditComponentList from './Admin/pages/EditComponentList';
import EditComponentDetails from './Admin/pages/EditComponentDetails';
import GenerateBill from './Admin/pages/GenerateBill';
import ViewBills from './Admin/pages/ViewBills';
import BillDetails from './Admin/pages/BillDetails';
import GenerateQuote from './Admin/pages/GenerateQuote';
import ViewQuotes from './Admin/pages/ViewQuotes';
import QuoteDetails from './Admin/pages/QuoteDetails';
import AddDesktop from './Admin/pages/AddDesktop';
import EditDesktopList from './Admin/pages/EditDesktopList';
import EditDesktopDetails from './Admin/pages/EditDesktopDetails';
import VerifyPage from './Verify/VerifyPage';
import reportWebVitals from './reportWebVitals';

window.addEventListener('error', (e) => {
  if (e.message === 'ResizeObserver loop limit exceeded') {
    e.stopImmediatePropagation();
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<RootView />} />
        <Route path="/verify" element={<VerifyPage />} />
        <Route path="/verify/:number" element={<VerifyPage />} />
        <Route path="/admin" element={<AdminLogin />} />
        <Route path="/admin/dashboard" element={<AdminDashboard />}>
          <Route path="add-pc" element={<AddPC />} />
          <Route path="edit-pc" element={<EditPCList />} />
          <Route path="edit-pc/:pcKey" element={<EditPCDetails />} />
          <Route path="add-component" element={<AddComponent />} />
          <Route path="edit-component" element={<EditComponentList />} />
          <Route path="edit-component/:compKey" element={<EditComponentDetails />} />
          <Route path="add-desktop" element={<AddDesktop />} />
          <Route path="edit-desktop" element={<EditDesktopList />} />
          <Route path="edit-desktop/:desktopKey" element={<EditDesktopDetails />} />
          <Route path="generate-bill" element={<GenerateBill />} />
          <Route path="view-bills" element={<ViewBills />} />
          <Route path="bill/:invoiceNumber" element={<BillDetails />} />
          <Route path="generate-quote" element={<GenerateQuote />} />
          <Route path="view-quotes" element={<ViewQuotes />} />
          <Route path="quote/:quoteNumber" element={<QuoteDetails />} />
        </Route>
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
